import { lazyWithPreload } from "./lazyWithPreload";

// Wrap every import in .then(...) to return { default: Component }
export const IndexPage = lazyWithPreload(() =>
  import("@/features/indexPage").then((mod) => ({ default: mod.IndexPage })),
);

export const Dashboard = lazyWithPreload(() =>
  import("@/features/dashboard").then((mod) => ({ default: mod.Dashboard })),
);

export const ApiDocs = lazyWithPreload(() =>
  import("@/features/api-docs").then((mod) => ({ default: mod.ApiDocs })),
);

export const FeatureRequest = lazyWithPreload(() =>
  import("@/features/feature-requests").then((mod) => ({
    default: mod.FeatureRequest,
  })),
);

export const ClickUp = lazyWithPreload(() =>
  import("@/features/clickUp").then((mod) => ({ default: mod.ClickUp })),
);

export const Bugs = lazyWithPreload(() =>
  import("@/features/bugs/index").then((mod) => ({ default: mod.Bugs })),
);

export const Shopify = lazyWithPreload(() =>
  import("@/features/shopify").then((mod) => ({ default: mod.Shopify })),
);

export const Settings = lazyWithPreload(() =>
  import("@/features/settings").then((mod) => ({ default: mod.Settings })),
);

export const PandaScore = lazyWithPreload(() =>
  import("@/features/pandaScore").then((mod) => ({ default: mod.PandaScore })),
);

export const PageNotFoundPage = lazyWithPreload(() =>
  import("@/features/page404").then((mod) => ({
    default: mod.PageNotFoundPage,
  })),
);
